/**
 * Marca de "carta ya vista" para el flujo de doble lectura del QR:
 * 1ª lectura → contenido intermedio (carta/página/agenda).
 * 2ª lectura (marca fresca) → propinas directamente.
 */
const KEY_PREFIX = "tipifyMenuVisto_";

export const MENU_VISIT_TTL_MS = 3 * 60 * 60 * 1000; // ~duración de una comida

export function markMenuVisited(businessId) {
  if (!businessId) return;
  try {
    localStorage.setItem(`${KEY_PREFIX}${businessId}`, String(Date.now()));
  } catch (e) {
    // localStorage no disponible (modo privado, etc.): sin marca, siempre 1ª lectura
  }
}

export function hasRecentMenuVisit(businessId) {
  if (!businessId) return false;
  try {
    const key = `${KEY_PREFIX}${businessId}`;
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) {
      localStorage.removeItem(key);
      return false;
    }
    if (Date.now() - ts > MENU_VISIT_TTL_MS) {
      localStorage.removeItem(key);
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}

/** Clave i18n del tab de contenido según el tipo configurado. */
export function getContenidoTabLabelKey(tipo) {
  if (tipo === "pagina_personalizada") return "landing.tabInfo";
  if (tipo === "agenda") return "landing.tabAgenda";
  return "landing.tabMenu";
}
